import {Component} from "@angular/core";
import {RouteService} from "../../../../services/routeService";
import {GeneralService} from "../../../../services/generalService";
import _ from "lodash";

@Component({
	selector: 'email-analyzer-tool-component',
	templateUrl: './email-analyzer-tool.component.html',
})

export class EmailAnalyzerToolComponent {
	constructor(private rs:RouteService,
				public gs:GeneralService) {
	}

	headersInputTxt;
	analyzeResult;
	analyzeResultInProcess;
	file;
	headers = {
		security: [],
		routing: [],
		x: [],
		other: []
	};

	analyzeEmail = () => {
		const base64Input = btoa(this.headersInputTxt);

		const data = {
			data: base64Input
		};

		this.analyzeResult = null;
		this.analyzeResultInProcess = true;
		this.rs.runTool('headerAnalyzer', data).then(result => {
			this.analyzeResult = result;
			this.analyzeResultInProcess = false;

			this.analyzeResult.totalHopsDelay = _.sumBy(this.analyzeResult.email?.hops || [], 'delay');

			this.headers = {
				security: getSecurityHeaders(this.analyzeResult.email.headers),
				routing: getRoutingHeaders(this.analyzeResult.email.headers),
				x: getXHeaders(this.analyzeResult.email.headers),
				other: []
			};
			this.headers.other = getOtherHeaders(this.analyzeResult.email.headers, this.headers.security, this.headers.x, this.headers.routing)
		}, err => {
			this.analyzeResultInProcess = false;
		});
	}

	uploadFile() {
		if (!this.file) {
			return;
		}

		if (this.file?.name.endsWith('.eml')) {
			const reader = new FileReader();

			reader.onload = (e: any) => {
				this.headersInputTxt = '';
				setTimeout(() => {
					this.headersInputTxt = e.target.result;
					this.analyzeEmail();
				}, 100);
			};
			reader.onerror = (err) => {
				console.error('Error reading file:', err);
			};
			reader.readAsText(this.file);
		}
	}
}

function getSecurityHeaders(emailHeaders) {
	const securityHeaderArr = emailHeaders.filter( (obj) => {
		if (obj.name.match(/^(ARC-)?Authentication-Results(?!-)/mgi) || obj.name.match(/^Received-SPF/mgi)
				|| obj.name.match(/^DKIM-Signature/mgi) || obj.name.match(/^ARC-Message-Signature/mgi) || obj.name.match(/^ARC-Seal/mgi)
				|| obj.name.match(/^x-microsoft-antispam/mgi) || obj.name.match(/^x-microsoft-antispam-message-info/mgi) || obj.name.match(/^x-ms-exchange-crosspremises-scl/mgi)
				|| obj.name.match(/^x-gm-phishy/mgi) || obj.name.match(/^x-gm-spam/mgi) || obj.name.match(/^x-forefront-antispam-report/mgi) || obj.name.match(/^x-ms-exchange-organization-scl/mgi)
				|| obj.name.match(/^x-authentication-results-original/mgi) || obj.name.match(/^authentication-results-original/mgi) || obj.name.match(/^x-ms-exchange-antispam-relay/mgi)) {
			return true;
		}
	});
	return securityHeaderArr;
}

function getRoutingHeaders(emailHeaders) {
	const routingHeaderArr = emailHeaders.filter((obj) => {
		if (/^Received$/mgi.test(obj.name) || /^Return-Path$/mgi.test(obj.name) || /^Delivered-To$/mgi.test(obj.name)
				|| /^X-Forwarded-To$/mgi.test(obj.name) || /^X-Received$/mgi.test(obj.name)) {
			return true;
		}
	});
	return routingHeaderArr;
}

function getXHeaders(emailHeaders) {
	const xHeaderArr = emailHeaders.filter((obj) => {
		if (obj.name.match(/^X-/mgi) && !obj.name.match(/^X-Received/mgi) &&
				!obj.name.match(/^x-forefront-antispam-report/mgi) && !obj.name.match(/^x-ms-exchange-organization-scl/mgi)
				&& !obj.name.match(/^X-microsoft-antispam/mgi) && !obj.name.match(/^x-gm-phishy/mgi) && !obj.name.match(/^x-gm-spam/mgi)
				&& !obj.name.match(/^x-microsoft-antispam-message-info/mgi) && !obj.name.match(/^x-ms-exchange-crosspremises-scl/mgi)
				&& !obj.name.match(/^x-authentication-results-original/mgi) && !obj.name.match(/^x-ms-exchange-antispam-relay/mgi)) {
			return true;
		}
	});
	return xHeaderArr;

}

function getOtherHeaders(emailHeaders, securityHeaders, xHeaders, routingHeaders) {
	const otherHeaders = emailHeaders.filter(header => {
		return !securityHeaders.some(secHeader => secHeader.name === header.name) &&
				!routingHeaders.some(routeHeader => routeHeader.name === header.name) &&
				!xHeaders.some(xHeader => xHeader.name === header.name);
	});

	return otherHeaders;
}
